import { RefObject, useEffect, useRef } from 'react';

import {
  isIdleWithoutData,
  MediaLoadingSnapshot,
} from './ui.video-player.helpers';

export const useIdleSuspendGuard = (
  mediaRef: RefObject<MediaLoadingSnapshot | null>,
  onIdle: () => void,
  graceMs: number
): (() => void) => {
  const timerRef = useRef<number | null>(null);

  useEffect(
    () => () => {
      if (timerRef.current !== null) window.clearTimeout(timerRef.current);
    },
    []
  );

  return () => {
    if (timerRef.current !== null) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      timerRef.current = null;
      const media = mediaRef.current;
      if (media && isIdleWithoutData(media)) onIdle();
    }, graceMs);
  };
};
